import { render, staticRenderFns } from "./CheckpointQuizBadge.vue?vue&type=template&id=1477f21f&scoped=true"
import script from "./CheckpointQuizBadge.vue?vue&type=script&setup=true&lang=js"
export * from "./CheckpointQuizBadge.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CheckpointQuizBadge.vue?vue&type=style&index=0&id=1477f21f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1477f21f",
  null
  
)

export default component.exports